import { render, staticRenderFns } from "./SwimpoolCoverPanelMaterials.vue?vue&type=template&id=9afeef70"
import script from "./SwimpoolCoverPanelMaterials.vue?vue&type=script&lang=ts"
export * from "./SwimpoolCoverPanelMaterials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports